import React from 'react';
import styled from 'styled-components';

interface TabCardsProps {
  onSelect?: (value: number) => void;
  selected?: number;
  options?: React.ReactNode[];
}

const TabCards: React.FC<TabCardsProps> = ({ onSelect = () => {}, selected, options }) => (
  <TabBar>
    {options?.map((item, i) => (
      <Card key={i} selected={selected === i} onClick={() => onSelect(i)}>
        {item}
      </Card>
    ))}
  </TabBar>
);
export default TabCards;

const TabBar = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  gap: 15px;
`;

const Card = styled.div<{ selected?: boolean }>`
  background-color: ${props => (props.selected ? '#b4d6c6' : '#f3f3f3')};
  border: 1px solid ${props => (props.selected ? '#999' : '#ddd')};
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  cursor: pointer;
  transition:
    background-color 0.2s,
    border-color 0.2s,
    all 0.2s ease-in-out;
  flex: 1 1 33.33%;

  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* Light drop shadow */

  &:hover {
    background-color: ${props => (props.selected ? '#b4d6c6' : '#dfdfdf')};
    border: 1px solid ${props => '#999'};
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3); /* Light drop shadow */
  }
`;
